<template lang="pug">
.generic-wrapper

  b-modal(v-model='showSendPaymentReminder1Modal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendPaymentReminderModal(:booking="selectedBooking"
                    :escalationLevel="1"
                    @close='props.close(); loadDashboard()')
  b-modal(v-model='showSendPaymentReminder2Modal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendPaymentReminderModal(:booking="selectedBooking"
                    :escalationLevel="2"
                    @close='props.close(); loadDashboard()')
  b-modal(v-model='showArrivalEmailModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      SendArrivalEmailModal(:booking="selectedBooking"
                    @refreshInbox="loadDashboard()"
                    @close='props.close()')

  .container
    h1.title Dashboard
    .sub-headline Behalten Sie den Überblick über Ihren finanziellen Status
    
    .card.margin-top(v-if="dashboard && dashboard.newBookings")
      .top
        .left
          .card-headline Neue Buchungen über die Webseite
          .card-description {{dashboard.newBookings.length}} {{dashboard.newBookings.length === 1 ? 'Buchung muss' : 'Buchungen müssen'}} noch bearbeitet werden.
        .right
      .main
        b-table(:data="bookingsWithSum(dashboard.newBookings)"
                default-sort-direction="desc"
                default-sort="totalPrice"
                hoverable
                @click="row => jumpToBookingInCalendar(row)")
          b-table-column(field='id' label='Vorgangs-Nr.' width='40' sortable centered numeric v-slot="props")
            | {{ props.row.id }}
          b-table-column(field='rentObject.name' label='Mietobjekt' sortable centered v-slot="props")
            | {{ props.row.rentObject.code }}
            br
            span.tag.is-light
              | {{ new Date(props.row.startDate).toLocaleDateString('de-DE', dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.customer.lastName }}
            span(v-if="props.row.customer.similiarCustomerId")
              .spacer.sm.inline
              UserCheckIcon(:id="props.row.customer.similiarCustomerId")
          b-table-column(field='customer.firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.customer.firstName }}
          b-table-column(field='createdAt' label='Buchungseingang' sortable centered v-slot="props")
            | {{ new Date(props.row.createdAt).toLocaleDateString('de-DE', dateTimeOptions) }}
          b-table-column(field='totalPrice' label='Gesamt' sortable v-slot="props")
            span.tag.is-success.is-medium
              |{{props.row.totalPrice / 100 | toCurrency}}
    
    .card.margin-top(v-if="dashboard && dashboard.newRequests")
      .top
        .left
          .card-headline Neue Anfragen über die Webseite
          .card-description {{dashboard.newRequests.length}} {{dashboard.newRequests.length === 1 ? 'Anfrage muss' : 'Anfragen müssen'}} noch bearbeitet werden.
        .right
      .main
        b-table(:data="dashboard.newRequests"
                default-sort-direction="asc"
                default-sort="createdAt"
                detailed
                hoverable)
          b-table-column(field='id' label='Anfrage-Nr.' width='40' sortable centered numeric v-slot="props")
            | {{ props.row.id }}
          b-table-column(field='lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.lastName }}
          b-table-column(field='firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.firstName }}
          b-table-column(field='createdAt' label='Eingang' sortable centered v-slot="props")
            | {{ new Date(props.row.createdAt).toLocaleDateString('de-DE', dateTimeOptions) }}
          b-table-column(field='comment' label='Kommentar' sortable v-slot="props")
            |{{props.row.comment}}
          b-table-column(label='Aktion' sortable v-slot="props")
            .button-wrapper
              b-button(v-if="props.row.customerId" @click="$router.push('/data/customers/edit/'+props.row.customerId)") Gast \#{{props.row.customerId}}
              b-button(v-else type="is-primary" @click.stop="createGuestFromRequest(props.row)") Gast anlegen
              template
                b-button(v-if="props.row.customerId" type="is-info" @click.stop="archiveRequest(props.row)") Archivieren
                b-button(v-else type="is-danger" @click.stop="deleteRequest(props.row)") Löschen
          template(#detail='props')
            article
              .content
                p
                  strong {{ props.row.title }} {{ props.row.firstName }} {{ props.row.lastName }}
                  br
                  |{{props.row.street}}
                  br
                  |{{props.row.zip}} {{props.row.city}}
                  br
                  |E-Mail: {{props.row.email}}
                  br
                  |Mobile: {{props.row.mobile}} Tel.:{{props.row.phone}}
                  br
                  |{{props.row.comment}}
    
    .card.margin-top(v-if="dashboard && dashboard.contractPaymentDelayBookings")
      .top.flex.between
        .left
          .card-headline Nicht bezahlte Mietverträge (A=Anzahlung; R=Restzahlung; G=Gesamtzahlung)
          .card-description {{dashboard.contractPaymentDelayBookings.length}} {{dashboard.contractPaymentDelayBookings.length === 1 ? 'Mietvertrag muss' : 'Mietverträge müssen'}} überprüft werden.
        .right
          .button-wrapper
            b-checkbox(size="is-small" type="is-light" v-model="showNichtMahnenBookings") {{hiddenNichtMahnenCounter}} nicht mahnen versteckt
            .spacer.sm
            .b-checkbox.checkbox.is-small Mahnschwelle in €
            b-numberinput(size="is-small" type="is-light" v-model="reminderThreshold")
      .main
        b-table(:data="paymentReminderBookings"
                default-sort-direction="asc"
                default-sort="paymentDueDate"
                :paginated="true"
                per-page="10")
          b-table-column(field='parentContract.id' label='MV-Nr.' width='40' centered v-slot="props")
            a(@click="jumpToBooking(props.row)") {{ props.row.parentContract.id }}
          b-table-column(field='rentObject.name' label='Mietobjekt' centered v-slot="props")
            | {{ props.row.rentObject.code }}
            br
            span.tag.is-light
              | {{ new Date(props.row.startDate).toLocaleDateString('de-DE', dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString('de-DE', dateOptions) }}

          b-table-column(field='customer.lastName' label='Nachname' v-slot="props")
            | {{ props.row.customer.lastName }}
          b-table-column(field='customer.firstName' label='Vorname' v-slot="props")
            | {{ props.row.customer.firstName }}
          b-table-column(field='paymentDueDate' label='Anz.' sortable centered v-slot="props")
            div(:style="{opacity: props.row.totalDownPayment - props.row.totalPayments > 0 ? 1 : 0.32}")
              div(:class="{red: props.row.downPaymentDueDate ? props.row.downPaymentDueDate <= new Date() && props.row.totalDownPayment - props.row.totalPayments > 0 : false}") {{ props.row.downPaymentDueDate ? props.row.downPaymentDueDate.toLocaleDateString('de-DE', dateOptions) : '-' }}
              span.tag.is-light(v-if="props.row.downPaymentDueDate")
                | {{props.row.totalDownPayment / 100 | toCurrency}}
          b-table-column(field='finalPaymentDueDate' label='Restz.' centered v-slot="props")
            div(:style="{opacity: props.row.finalPaymentDueDate <= new Date() ? 1 : 0.32}")
              div(:class="{red: props.row.finalPaymentDueDate <= new Date()}") {{ props.row.finalPaymentDueDate.toLocaleDateString('de-DE', dateOptions) }}
              span.tag.is-light
                | {{props.row.totalFinalPayment / 100 | toCurrency}}
          b-table-column(field='totalPrice' label='Gesamt' numeric v-slot="props")
            | {{props.row.totalPrice / 100 | toCurrency}}
          b-table-column(field='totalPayments' label='Gezahlt' numeric v-slot="props")
            .green {{props.row.totalPayments / 100 | toCurrency}}
          b-table-column(field='totalPaymentDue' label='Ausstehend' centered v-slot="props")
            span.tag.is-medium(:class="{'is-danger': props.row.totalPaymentDue - props.row.totalPayments >= 0, 'is-success': props.row.totalPaymentDue - props.row.totalPayments < 0}")
              | {{props.row.paymentType}}: {{(props.row.totalPaymentDue - props.row.totalPayments)  / 100 | toCurrency}}
          b-table-column(label='nicht mahnen' centered v-slot="props")
            .flex
              b-checkbox(:key="'A'+props.row.id" :disabled="!props.row.downPaymentDueDate" type="is-success" :value="props.row.disableDownPaymentReminder" @input="e => updateDisablePaymentReminder(props.row.id, 'A', e)") A
            .flex
              b-checkbox(:key="'R'+props.row.id" type="is-success" :value="props.row.disableFinalPaymentReminder" @input="e => updateDisablePaymentReminder(props.row.id, 'R', e)") R
          b-table-column(label='Erinnerung' centered v-slot="props")
            b-button(:disabled="(['A'].includes(props.row.paymentType) && props.row.disableDownPaymentReminder) || (['R'].includes(props.row.paymentType) && props.row.disableFinalPaymentReminder) || (['G'].includes(props.row.paymentType) && props.row.disableDownPaymentReminder && props.row.disableFinalPaymentReminder) || (['G'].includes(props.row.paymentType) && !props.row.downPaymentDueDate && props.row.disableFinalPaymentReminder)" type="is-flat" icon-left="reminder" @click="jumpToBookingInCalendar(props.row, 'openPaymentReminder1')")
            span.tag.is-light(v-if="props.row.paymentReminders.filter(p => p.escalationLevel === 1).length > 0" :class="{'is-danger': new Date() >= new Date(props.row.paymentReminders.filter(p => p.escalationLevel === 1)[props.row.paymentReminders.filter(p => p.escalationLevel === 1).length - 1].dueDate)}")
              | {{new Date(props.row.paymentReminders.filter(p => p.escalationLevel === 1)[props.row.paymentReminders.filter(p => p.escalationLevel === 1).length - 1].dueDate).toLocaleDateString('de-DE', dateOptions)}}
          b-table-column(label='Mahnung' centered v-slot="props")
            b-button(:class="{blink: checkIfBlinkNeeded(props.row), blink2: checkIfBlink2Needed(props.row)}" :disabled="(['R'].includes(props.row.paymentType) && props.row.disableFinalPaymentReminder) || (['A'].includes(props.row.paymentType) && props.row.disableDownPaymentReminder) || (['G'].includes(props.row.paymentType) && props.row.disableDownPaymentReminder && props.row.disableFinalPaymentReminder) || (['G'].includes(props.row.paymentType) && !props.row.downPaymentDueDate && props.row.disableFinalPaymentReminder)" type="is-flat" icon-left="alert-decagram" @click="jumpToBookingInCalendar(props.row, 'openPaymentReminder2')")
            span.tag.is-light(v-if="props.row.paymentReminders.filter(p => p.escalationLevel === 2).length > 0" :class="{'is-danger': new Date() >= new Date(props.row.paymentReminders.filter(p => p.escalationLevel === 2)[props.row.paymentReminders.filter(p => p.escalationLevel === 2).length - 1].dueDate)}")
              | {{new Date(props.row.paymentReminders.filter(p => p.escalationLevel === 2)[props.row.paymentReminders.filter(p => p.escalationLevel === 2).length - 1].dueDate).toLocaleDateString('de-DE', dateOptions)}}
          b-table-column(label='Info' centered v-slot="props")
            b-button(:type="props.row.comment && props.row.comment.length > 0 ? 'is-info' : 'is-flat'" icon-left="message-reply-text" @click="openCommentModal(props.row.id, props.row.comment)")

    .card.margin-top(v-if="digitalSignatureDocuments.length > 0")
      .top
        .left
          .card-headline Digital signierte Verträge
          .card-description Hier sehen Sie alle digital signatierten Verträge, welche noch nicht gedruckt wurden.
        .right
      .main
        b-table(:data="digitalSignatureDocuments"
                default-sort-direction="desc"
                default-sort="createdAt"
                hoverable
                @click="row => jumpToBooking(row.parentContract.rentObjectBooking)")
          b-table-column(field='parentContractId' label='Vertrags-Nr.' width='40' sortable centered numeric v-slot="props")
            | {{ props.row.parentContractId }}
            br
            a(@click.stop="() => {}" :href="props.row.digitalSignatureDocumentSrc" target="_blank")
              b-button(type="is-primary" size="is-small" iconLeft="file-document-outline") Öffnen
          b-table-column(field='rentObject.name' label='Mietobjekt' sortable centered v-slot="props")
            | {{ props.row.parentContract.rentObjectBooking.rentObject.code }}
            br
            span.tag.is-light
              | {{ new Date(props.row.parentContract.rentObjectBooking.startDate).toLocaleDateString('de-DE', dateOptions) }} - {{ new Date(props.row.parentContract.rentObjectBooking.endDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.parentContract.rentObjectBooking.customer.lastName }}
          b-table-column(field='customer.firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.parentContract.rentObjectBooking.customer.firstName }}
          b-table-column(field='digitalSignatureDate' label='Signiert am' sortable centered v-slot="props")
            | {{ new Date(props.row.digitalSignatureDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(label='Aktion' sortable centered v-slot="props")
            b-button(type="is-flat" v-model="props.row.isPrintedOnPaper" @click.stop="updateIsPrintedOnPaper(props.row)" iconLeft="printer") ist ausgedruckt?

    .card.margin-top(v-if="dashboard && dashboard.optionDelayBookings")
      .top
        .left
          .card-headline Nicht gewandelte Optionen
          .card-description {{dashboard.optionDelayBookings.length}} {{dashboard.optionDelayBookings.length === 1 ? 'Option wartet' : 'Optionen warten'}} darauf gewandelt zu werden.
        .right
      .main
        b-table(:data="bookingsWithSum(dashboard.optionDelayBookings)"
                default-sort-direction="asc"
                default-sort="optionEndDate"
                hoverable
                @click="row => jumpToBookingInCalendar(row)")
          b-table-column(field='id' label='Vorgangs-Nr.' width='40' sortable centered numeric v-slot="props")
            | {{ props.row.id }}
          b-table-column(field='rentObject.name' label='Mietobjekt' sortable centered v-slot="props")
            | {{ props.row.rentObject.code }}
            br
            span.tag.is-light
              | {{ new Date(props.row.startDate).toLocaleDateString('de-DE', dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.customer.lastName }}
          b-table-column(field='customer.firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.customer.firstName }}
          b-table-column(field='createdAt' label='Erstellt am' sortable centered v-slot="props")
            | {{ new Date(props.row.updatedAt).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='optionEndDate' label='Optionsende' centered sortable v-slot="props")
            div(:class="{red: props.row.optionEndDate ? new Date(props.row.optionEndDate) <= new Date() : false}") {{ props.row.optionEndDate ? new Date(props.row.optionEndDate).toLocaleDateString('de-DE', dateOptions) : 'Optionsende fehlt' }}
          b-table-column(field='totalPrice' label='Gesamtbetrag' sortable numeric v-slot="props")
            span.tag.is-success.is-medium
              |{{props.row.totalPrice / 100 | toCurrency}}

    .card.margin-top(v-if="dashboard && dashboard.arrivalSoonBookings && dashboard.arrivalSoonBookings.length > 0")
      .top
        .left
          .card-headline Neue Buchungen kurz vor der Anreise
          .card-description {{dashboard.arrivalSoonBookings.length}} {{dashboard.arrivalSoonBookings.length === 1 ? 'Gast wird' : 'Gäste werden'}} demnächst anreisen.
        .right
      .main
        b-table(:data="bookingsWithSum(dashboard.arrivalSoonBookings)"
                default-sort-direction="desc"
                default-sort="createdAt"
                hoverable)
          b-table-column(field='id' label='Vorgangs-Nr.' width='40' sortable centered numeric v-slot="props")
            a(@click="jumpToBooking(props.row)") {{ props.row.parentContract.id }}
          b-table-column(field='rentObject.name' label='Mietobjekt' sortable centered v-slot="props")
            | {{ props.row.rentObject.code }}
            br
            span.tag.is-light
              | {{ new Date(props.row.startDate).toLocaleDateString('de-DE', dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.customer.lastName }}
          b-table-column(field='customer.firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.customer.firstName }}
          b-table-column(field='createdAt' label='Anreise am' sortable centered v-slot="props")
            | {{ new Date(props.row.startDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='totalPrice' label='Gesamtbetrag' sortable numeric v-slot="props")
            span.tag.is-success.is-medium
              |{{props.row.totalPrice / 100 | toCurrency}}
          b-table-column(label='Aktion' centered v-slot="props")
            .button-wrapper
                b-button(type="is-primary" @click="jumpToBookingInCalendar(props.row, 'openArrivalEmailModal')") Anreise E-Mail öffnen
                b-button(:type="props.row.comment && props.row.comment.length > 0 ? 'is-info' : 'is-flat'" icon-left="message-reply-text" @click="openCommentModal(props.row.id, props.row.comment)")
            .has-email(style="text-align: left; font-size: 0.8rem;") E-Mail liegt vor: {{props.row.customer.address.email ? '✅' : '❌'}}
          b-table-column(label='' centered v-slot="props")
            b-button(type="is-danger" @click="archiveArrivalEmail(props.row.id)" icon-left="close")
    
    .card.margin-top(v-if="dashboard && dashboard.cancelInvoicePaymentDelayBookings")
      .top
        .left
          .card-headline Nicht bezahlte Stornorechnungen
          .card-description {{dashboard.cancelInvoicePaymentDelayBookings.length}} {{dashboard.cancelInvoicePaymentDelayBookings.length === 1 ? 'Stornorechnung muss' : 'Stornorechnungen müssen'}} überprüft werden.
        .right
      .main
        b-table(:data="bookingsWithSum(dashboard.cancelInvoicePaymentDelayBookings, 'cancel')"
                default-sort-direction="asc"
                default-sort="paymentDueDate"
                hoverable
                @click="row => jumpToBookingInCalendar(row)")
          b-table-column(label='Storno-Nr.' width='40' centered numeric v-slot="props")
            | {{ props.row.cancelInvoices[props.row.cancelInvoices.length - 1].id }}
          b-table-column(field='rentObject.name' label='Mietobjekt' sortable centered v-slot="props")
            | {{ props.row.rentObject.code }}
            br
            span.tag.is-light
              | {{ new Date(props.row.startDate).toLocaleDateString('de-DE', dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.customer.lastName }}
          b-table-column(field='customer.firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.customer.firstName }}
          b-table-column(field='paymentDueDate' label='Zahlungsfrist' sortable centered v-slot="props")
            | {{ props.row.paymentDueDate.toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='totalPrice' label='Gesamt' sortable v-slot="props")
            |{{props.row.cancelInvoices[props.row.cancelInvoices.length - 1].totalPrice / 100 | toCurrency}}
          b-table-column(field='leftPayment' label='Ausstehend' sortable numeric v-slot="props")
            span.tag.is-medium(:class="{'is-danger': props.row.leftPayment > 0, 'is-success': props.row.leftPayment <= 0}")
              |{{props.row.leftPayment / 100 | toCurrency}}
    
    .card.margin-top(v-if="dashboard && dashboard.cancelBookingWithoutInvoice")
      .top
        .left
          .card-headline Stornierungen ohne Rechnung
          .card-description {{dashboard.cancelBookingWithoutInvoice.length}} {{dashboard.cancelBookingWithoutInvoice.length === 1 ? 'Storniernung muss' : 'Stornierungen müssen'}} überprüft werden.
        .right
      .main
        b-table(:data="bookingsWithSum(dashboard.cancelBookingWithoutInvoice)"
                default-sort-direction="asc"
                default-sort="paymentDueDate"
                hoverable
                @click="row => jumpToBookingInCalendar(row)")
          b-table-column(field='id' label='Vorgangs-Nr.' width='40' sortable centered numeric v-slot="props")
            | {{ props.row.id }}
          b-table-column(field='rentObject.name' label='Mietobjekt' sortable centered v-slot="props")
            | {{ props.row.rentObject.code }}
            br
            span.tag.is-light
              | {{ new Date(props.row.startDate).toLocaleDateString('de-DE', dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.customer.lastName }}
          b-table-column(field='customer.firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.customer.firstName }}
          b-table-column(field='comment' label='Kommentar' sortable v-slot="props")
            p {{ props.row.comment }}
    
    .card.margin-top(v-if="dashboard && dashboard.gdprDeleteBookings")
      .top
        .left
          .card-headline Zu anonymisierende Buchungen nach DSGVO
          .card-description {{dashboard.gdprDeleteBookings.length}} {{dashboard.gdprDeleteBookings.length === 1 ? 'Buchung muss' : 'Buchungen müssen'}} gemäß DSGVO anonymisiert werden.
        .right
      .main
        b-table(:data="bookingsWithSum(dashboard.gdprDeleteBookings)"
                default-sort-direction="desc"
                default-sort="daysAfterDeparture"
                hoverable
                @click="row => jumpToBookingInCalendar(row)")
          b-table-column(field='id' label='Vorgangs-Nr.' width='40' sortable centered numeric v-slot="props")
            | {{ props.row.id }}
          b-table-column(field='rentObject.name' label='Mietobjekt' sortable centered v-slot="props")
            | {{ props.row.rentObject.code }}
            br
            span.tag.is-light
              | {{ new Date(props.row.startDate).toLocaleDateString('de-DE', dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString('de-DE', dateOptions) }}
          b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
            | {{ props.row.customer.lastName }}
          b-table-column(field='customer.firstName' label='Vorname' sortable v-slot="props")
            | {{ props.row.customer.firstName }}
          b-table-column(field='daysAfterDeparture' label='Abreisedatum' sortable centered v-slot="props")
            | {{ new Date(props.row.endDate).toLocaleDateString('de-DE', dateOptions) }} (vor {{props.row.daysAfterDeparture}} {{props.row.daysAfterDeparture === 1 ? 'Tag' : 'Tagen'}})
          b-table-column(label='Aktion' sortable v-slot="props")
            b-button(type="is-danger" @click.stop="anonymizeBookingData(props.row)") Anonymisieren

  b-modal(v-model='isCommentModalOpen' has-modal-card='' trap-focus='' :destroy-on-hide='true' aria-role='dialog' aria-modal='')
    template(#default='props')
      .card.form.w320.margin-top
        .top
          h2.title.is-6 Kommentar aktualisieren
          ValidationObserver(v-slot="{ handleSubmit }", ref="form")
            ValidationProvider(
              name="Kommentar",
              rules="",
              v-slot="{ errors, valid }")
              b-field(
                :message="errors")
                b-input(type="textarea" v-model="commentModalInfo.comment" maxlength="3000")
            .button-wrapper.margin-top.right
              b-button(
                type="is-light",
                @click="isCommentModalOpen = false"
              ) Abbrechen
              b-button(
                type="is-primary",
                @click="handleSubmit(updateComment)"
              ) Aktualisieren

</template>

<script>
import { DateTime } from 'luxon';
import UserCheckIcon from '@/components/molecules/UserCheckIcon.vue';
import SendPaymentReminderModal from '@/components/molecules/SendPaymentReminderModal.vue';
import SendArrivalEmailModal from '@/components/molecules/SendArrivalEmailModal.vue';

export default {
  components: {
    SendPaymentReminderModal,
    SendArrivalEmailModal,
    UserCheckIcon
  },
  data() {
    return {
      isCommentModalOpen: false,
      showArrivalEmailModal: false,
      commentModalInfo: {
        id: null,
        comment: null
      },
      showNichtMahnenBookings: true,
      reminderThreshold: 0,
      dashboard: null,
      digitalSignatureDocuments: [],
      openInoviceBookings: [],
      dateOptions: {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit"
      },
      dateTimeOptions: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      },
      showSendPaymentReminder1Modal: false,
      showSendPaymentReminder2Modal: false,
      selectedBooking: null
    };
  },
  computed: {
    paymentReminderBookings() {
      return this.bookingsWithSum(this.dashboard.contractPaymentDelayBookings).filter(c => {
        const downPaymentIsDue = c.downPaymentDueDate && c.downPaymentDueDate <= new Date() && c.totalDownPayment - c.totalPayments > 0;
        const finalPaymentIsDue = c.finalPaymentDueDate <= new Date();
        const isAboveReminderThreshold = (c.totalPaymentDue - c.totalPayments)/100 > this.reminderThreshold;
        if (isAboveReminderThreshold && (downPaymentIsDue || finalPaymentIsDue)) {
          if (this.showNichtMahnenBookings && ((['A'].includes(c.paymentType) && c.disableDownPaymentReminder) || (['R'].includes(c.paymentType) && c.disableFinalPaymentReminder) || (['G'].includes(c.paymentType) && c.disableDownPaymentReminder && c.disableFinalPaymentReminder) || (['G'].includes(c.paymentType) && !c.downPaymentDueDate && c.disableFinalPaymentReminder)) && ((['R'].includes(c.paymentType) && c.disableFinalPaymentReminder) || (['A'].includes(c.paymentType) && c.disableDownPaymentReminder) || (['G'].includes(c.paymentType) && c.disableDownPaymentReminder && c.disableFinalPaymentReminder) || (['G'].includes(c.paymentType) && !c.downPaymentDueDate && c.disableFinalPaymentReminder))) {
            // Nothing
          } else {
            return c;
          }
        }
      });
    },
    hiddenNichtMahnenCounter() {
      let hiddenNichtMahnenCounterValue = 0;
      this.bookingsWithSum(this.dashboard.contractPaymentDelayBookings).forEach(c => {
        const downPaymentIsDue = c.downPaymentDueDate && c.downPaymentDueDate <= new Date() && c.totalDownPayment - c.totalPayments > 0;
        const finalPaymentIsDue = c.finalPaymentDueDate <= new Date();
        const isAboveReminderThreshold = (c.totalPaymentDue - c.totalPayments)/100 > this.reminderThreshold;
        if (isAboveReminderThreshold && (downPaymentIsDue || finalPaymentIsDue)) {
          if (this.showNichtMahnenBookings && ((['A'].includes(c.paymentType) && c.disableDownPaymentReminder) || (['R'].includes(c.paymentType) && c.disableFinalPaymentReminder) || (['G'].includes(c.paymentType) && c.disableDownPaymentReminder && c.disableFinalPaymentReminder) || (['G'].includes(c.paymentType) && !c.downPaymentDueDate && c.disableFinalPaymentReminder)) && ((['R'].includes(c.paymentType) && c.disableFinalPaymentReminder) || (['A'].includes(c.paymentType) && c.disableDownPaymentReminder) || (['G'].includes(c.paymentType) && c.disableDownPaymentReminder && c.disableFinalPaymentReminder) || (['G'].includes(c.paymentType) && !c.downPaymentDueDate && c.disableFinalPaymentReminder))) {
            // Nothing
            hiddenNichtMahnenCounterValue += 1;
          }
        }
      });
      return hiddenNichtMahnenCounterValue;
    },
    bookings() {
      return this.$store.state.rentObjectBookings.all;
    },
  },
  methods: {
    async updateIsPrintedOnPaper(contract) {
      this.$buefy.dialog.confirm({
        title: "Vertrags-Nr. " + contract.parentContractId,
        message: `Wurde der Vertrag ausgedruckt und abgelegt?`,
        confirmText: "Ja, wurde ausgedruckt",
        cancelText: "Abbrechen",
        type: "is-success",
        hasIcon: true,
        onConfirm: async () => {
          try {
            const loadingComponent = this.$buefy.loading.open();
            await this.$store.dispatch("contracts/setIsPrintedOnPaper", {id: contract.id, state: true});
            this.digitalSignatureDocuments = await this.$store.dispatch("contracts/getDigitalSignatureContractsNotPrinted");
            loadingComponent.close();
          } catch (e) {
            // nothing here
          }
        },
      });
    },
    checkIfBlinkNeeded(booking) {
      const paymentReminders1 = booking.paymentReminders.filter(p => p.escalationLevel === 1);
      const paymentReminders2 = booking.paymentReminders.filter(p => p.escalationLevel === 2);
      const paymentReminder1 = paymentReminders1.length > 0 ? paymentReminders1[paymentReminders1.length - 1] : null;
      const paymentReminder2 = paymentReminders2.length > 0 ? paymentReminders2[paymentReminders2.length - 1] : null;
      if (!paymentReminder1) return false;

      // Wenn eine Anzahlung erfolgreich gelistet wurde, dann darf bei einem Versäumnis
      // der Restzahlung nicht direkt Stufe zwei blinken
      let totalPayments = 0;
      const contract = booking.parentContract.contracts[booking.parentContract.contracts.length - 1];
      for (let i = 0; i < booking.payments.length; i += 1) {
        totalPayments += booking.payments[i].total;
      }
      if (contract.totalDownPayment <= totalPayments && new Date(paymentReminder1.createdAt) < new Date(contract.finalPaymentDueDate)) {
        return false;
      }
      if (new Date(paymentReminder1.dueDate) < new Date() && !paymentReminder2) {
        return true;
      }
      return false;
    },
    checkIfBlink2Needed(booking) {
      const paymentReminders1 = booking.paymentReminders.filter(p => p.escalationLevel === 1);
      const paymentReminders2 = booking.paymentReminders.filter(p => p.escalationLevel === 2);
      const paymentReminder1 = paymentReminders1.length > 0 ? paymentReminders1[paymentReminders1.length - 1] : null;
      const paymentReminder2 = paymentReminders2.length > 0 ? paymentReminders2[paymentReminders2.length - 1] : null;
      if (!paymentReminder2) return false;

      // Wenn eine Anzahlung erfolgreich gelistet wurde, dann darf bei einem Versäumnis
      // der Restzahlung nicht direkt Stufe zwei blinken
      let totalPayments = 0;
      const contract = booking.parentContract.contracts[booking.parentContract.contracts.length - 1];
      for (let i = 0; i < booking.payments.length; i += 1) {
        totalPayments += booking.payments[i].total;
      }
      if (contract.totalDownPayment <= totalPayments && new Date(paymentReminder2.createdAt) < new Date(contract.finalPaymentDueDate)) {
        return false;
      }
      if (paymentReminder1 && new Date(paymentReminder1.dueDate) > new Date(paymentReminder2.dueDate)) {
        return false;
      }
      if (new Date(paymentReminder2.dueDate) < new Date()) {
        return true;
      }
      return false;
    },
    async updateDisablePaymentReminder(id, paymentType, value) {
      await this.$store.dispatch("rentObjectBookings/updateDisablePaymentReminder", {id, paymentType, value});
      this.loadDashboard();
    },
    addDaysToDate(rawDate, days) {
      let d = new Date(rawDate);
      d.setDate(d.getDate() + days);
      return d;
    },
    archiveArrivalEmail(rentObjectBookingId) {
      this.$buefy.dialog.confirm({
        title: "Anreise E-Mail ausblenden",
        message: `Sind Sie sicher, dass Sie den Hinweis der Anreise E-Mail ausblenden wollen?`,
        confirmText: "Ja",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("rentObjectBookings/archiveArrivalEmail", {rentObjectBookingId});
            this.dashboard = await this.$store.dispatch("rentObjectBookings/getDashboard");
          } catch (e) {
            // nothing here
          }
        },
      });
    },
    anonymizeBookingData(booking) {
      this.$buefy.dialog.confirm({
        title: "Gastdaten anonymisieren",
        message: `Sind Sie sicher, dass Sie die Buchung mit dem Gast <b>${booking.customer.firstName} ${booking.customer.lastName}</b> anonymisieren möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt anonymisieren",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("rentObjectBookings/anonymize", {id: booking.id});
            this.dashboard = await this.$store.dispatch("rentObjectBookings/getDashboard");
          } catch (e) {
            // nothing here
          }
        },
      });
    },
    async createGuestFromRequest(request) {
      try {
        await this.$store.dispatch("bookingRequests/createCustomer", {id: request.id});
        this.dashboard = await this.$store.dispatch("rentObjectBookings/getDashboard");
      } catch (e) {
        // nothing here
      }
    },
    async archiveRequest(request) {
      this.$buefy.dialog.confirm({
        title: "Anfrage archivieren",
        message: `Sind Sie sicher, dass Sie die Anfrage mit dem Gast <b>${request.firstName} ${request.lastName}</b> archivieren möchten?`,
        confirmText: "Jetzt archivieren",
        cancelText: "Abbrechen",
        type: "is-info",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("bookingRequests/delete", {id: request.id});
            this.dashboard = await this.$store.dispatch("rentObjectBookings/getDashboard");
          } catch (e) {
            // nothing here
          }
        },
      });
    },
    async deleteRequest(request) {
      this.$buefy.dialog.confirm({
        title: "Anfrage löschen",
        message: `Sind Sie sicher, dass Sie die Anfrage mit dem Gast <b>${request.firstName} ${request.lastName}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("bookingRequests/delete", {id: request.id});
            this.dashboard = await this.$store.dispatch("rentObjectBookings/getDashboard");
          } catch (e) {
            // nothing here
          }
        },
      });
    },
    jumpToBookingInCalendar(booking, action) {
      this.selectedBooking = booking;
      if (action === "openArrivalEmailModal") {
        this.showArrivalEmailModal = true;
        return;
      }
      if (action === "openPaymentReminder1") {
        this.showSendPaymentReminder1Modal = true;
        return;
      }
      if (action === "openPaymentReminder2") {
        this.showSendPaymentReminder2Modal = true;
        return;
      }
      this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(booking.startDate).toHTTP(), jumpObjectId: booking.rentObjectId, bookingStatusId: booking.bookingStatusId}})
    },
    jumpToBooking(booking) {
      this.$router.push({name: 'Booking', params: {id: booking.id}});
    },
    bookingsWithSum(bookings, cancel) {
      return bookings.map(b => {
        let totalPrice = 0;
        let totalPayments = 0;
        for (let i = 0; i < b.bookingItems.length; i += 1) {
          totalPrice += b.bookingItems[i].totalPrice;
        }
        for (let i = 0; i < b.payments.length; i += 1) {
          totalPayments += b.payments[i].total;
        }
        let leftPayment = 0;
        let paymentDueDate = null;
        let finalPaymentDueDate = null;
        let downPaymentDueDate = null;
        let totalPaymentDue = 0;
        let totalDownPayment = 0;
        let totalFinalPayment = 0;
        let paymentType = 'A';
        if (cancel && b.cancelInvoices && b.cancelInvoices[b.cancelInvoices.length - 1]) {
        
          const cancelInvoice = b.cancelInvoices[b.cancelInvoices.length - 1];
          leftPayment = cancelInvoice.totalPrice - totalPayments;
          paymentDueDate = new Date(cancelInvoice.paymentDueDate);
        
        } else if (b.parentContract && b.parentContract.contracts && b.parentContract.contracts[b.parentContract.contracts.length - 1]) {
          
          const contract = b.parentContract.contracts[b.parentContract.contracts.length - 1];
          finalPaymentDueDate = new Date(contract.finalPaymentDueDate); 
          downPaymentDueDate = contract.downPaymentDueDate ? new Date(contract.downPaymentDueDate) : contract.downPaymentDueDate;
          totalDownPayment = contract.totalDownPayment ?? 0;
          totalFinalPayment = contract.totalFinalPayment ?? 0;
          if (contract.downPaymentDueDate && (contract.totalDownPayment - totalPayments) > 0) {
            leftPayment = contract.totalDownPayment - totalPayments;
            totalPaymentDue = contract.totalDownPayment;
            paymentDueDate = new Date(contract.downPaymentDueDate);
            if (new Date(contract.finalPaymentDueDate) <= new Date()) {
              paymentType = 'G';
              totalPaymentDue = contract.totalPrice;
              if (b.disableDownPaymentReminder) {
                paymentDueDate = new Date(contract.finalPaymentDueDate);
              }
            }
          } else {
            paymentType = 'R';
            if (!contract.downPaymentDueDate) paymentType = 'G';
            leftPayment = contract.totalPrice - totalPayments;
            totalPaymentDue = contract.totalFinalPayment;
            paymentDueDate = new Date(contract.finalPaymentDueDate);
            if (paymentDueDate <= new Date()) {
              totalPaymentDue = contract.totalPrice;
            }
          }
        }
        const daysAfterDeparture = Math.ceil(DateTime.local().diff(DateTime.fromISO(b.endDate), 'days').toObject().days);
        return {...b, totalPrice, totalDownPayment, totalFinalPayment, totalPayments, leftPayment, paymentDueDate, finalPaymentDueDate, downPaymentDueDate, daysAfterDeparture, paymentType, totalPaymentDue};
      })
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.toLocaleString({
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    async loadDashboard() {
      const loadingComponent = this.$buefy.loading.open();
      this.dashboard = await this.$store.dispatch("rentObjectBookings/getDashboard");
      this.digitalSignatureDocuments = await this.$store.dispatch("contracts/getDigitalSignatureContractsNotPrinted");
      loadingComponent.close();
    },
    openCommentModal(id, comment) {
      this.isCommentModalOpen = true;      
      this.commentModalInfo = {
        id,
        comment
      };
    },
    async updateComment() {
      const booking = await this.$store.dispatch("rentObjectBookings/updateComment", { ...this.commentModalInfo });
      const oldBooking = this.paymentReminderBookings.find(b => b.id === booking.id);
      if (oldBooking) {
        oldBooking.comment = this.commentModalInfo.comment
      }
      this.isCommentModalOpen = false;
    }
  },
  mounted() {
    this.loadDashboard();
    // this.dashboard = await this.$store.dispatch("rentObjectBookings/getChannelRequests");
  }
};
</script>

<style lang="scss" scoped>
.red {
  color: $danger;
}
.green {
  color: $success;
}
.tag {
  width: 100%;
}
.blink {
  animation: blink 1s infinite;
  border-color: red;
}
@keyframes blink {
  50% {
    border-color: white;
    // opacity: 0.0;
  }
}
.blink2 {
  animation: blink2 1s infinite;
  background-color: red;
}
@keyframes blink2 {
  50% {
    background-color: white;
    // opacity: 0.0;
  }
}
</style>